import Glightbox from "glightbox";
import Splide from "@splidejs/splide";

function initLightbox() {
    const lightbox = Glightbox({
        selector: '.glightbox',
        loop: true
    });
}

function initMenu() {

    const TOGGLE_SEARCH = document.querySelector('#jsToggleSearch'),
          SEARCH_INPUT = document.querySelector('#s'),
          TOGGLE_MENU = document.querySelector('#jsToggleMenu'),
          PAGE_OVERLAY = document.querySelector('#pageOverlay');


    if(TOGGLE_SEARCH) {
        TOGGLE_SEARCH.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            document.body.classList.toggle('search-opened');

            if(SEARCH_INPUT) {
                setTimeout(() => {
                    SEARCH_INPUT.focus({preventScroll: true});
                });
            }
        });
    }

    if(TOGGLE_MENU) {
        TOGGLE_MENU.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.toggle('menu-opened');
        });
    }

    if(PAGE_OVERLAY) {
        PAGE_OVERLAY.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.remove('menu-opened');
        });
    }
}

function initRealizationSlider() {
    const el = document.getElementById( 'realization-slider' );
    if ( ! el ) return;
    new Splide( el, {
        perPage: 4,
        gap: '24px',
        type: 'slide',
        pagination: false,
        drag: true,
        interval: 4000,
        breakpoints: {
            1200: { perPage: 3 },
            991: { perPage: 2 },
            767: { perPage: 1 },
        },
    } ).mount();
}

function initPromoPopup() {
    const el = document.getElementById('promo-popup');
    if (!el) return;
    const version = el.dataset.version;
    const SK  = 'popup-dismissed';
    const TTL = 24 * 60 * 60 * 1000;

    const raw = sessionStorage.getItem(SK);
    if (raw) {
        try {
            const { v, t } = JSON.parse(raw);
            if (v === version && Date.now() - t < TTL) return;
        } catch (_) {}
    }

    if (el.querySelector('.splide__list li + li')) {
        const splide = new Splide('#promo-popup .splide', {
            type: 'loop',
            autoplay: true,
            interval: 20000,
            pauseOnHover: true,
            arrows: false,
            pagination: false,
        });
        const track = el.querySelector('.splide__track');
        splide.on('active', (slide) => {
            track.style.height = slide.slide.offsetHeight + 'px';
        });
        splide.mount();
    }
    setTimeout(() => el.classList.add('is-visible'), 1500);
    el.querySelector('.promo-popup__close').addEventListener('click', () => {
        el.classList.remove('is-visible');
        sessionStorage.setItem(SK, JSON.stringify({ v: version, t: Date.now() }));
    });
}

function initScrollToTop() {
    const SCROLL_TO_TOP = document.querySelector('#scrollToTop');

    if(!SCROLL_TO_TOP) {
        return;
    }

    let isThrottled = false;
    const THROTTLE_DURATION = 200; // ms

    window.addEventListener('scroll', () => {

        if (isThrottled) {
            return;
        }
        isThrottled = true;

        setTimeout(() => {
            // Use toggle with a boolean for a cleaner add/remove
            SCROLL_TO_TOP.classList.toggle('--visible', window.scrollY > 300);
            isThrottled = false;
        }, THROTTLE_DURATION);

    }, { passive: true });

    SCROLL_TO_TOP.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
}


function initHeaderScroll() {
    const HEADER = document.querySelector('.header');
    if (!HEADER) return;

    window.addEventListener('scroll', () => {
        HEADER.classList.toggle('header--scrolled', window.scrollY > 0);
    });
}

document.addEventListener("DOMContentLoaded", function() {
    initMenu();
    initHeaderScroll();
    // initWPCF7();
    // initAccordions();
    // initGallery();
    initLightbox();
    initScrollToTop();
    initRealizationSlider();
    initPromoPopup();
    // addStickyToHeader();
});

